<template>
  <div class="view-guest">
    <GamesList :list="list" />
  </div>
</template>

<script>
import GamesList from '~/components/Lobby/SearchModal/components/GamesList'

export default {
  name: 'ViewGuest',
  components: {
    GamesList,
  },
  props: {
    list: { type: Array },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
